import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomeTestPage from './components/Home/HomeTestPage';
import Session from './components/Session/Session';
import NotFound from './components/NotFound/NotFound';
import ChecksPage from './components/ChecksPage/ChecksPage';
import NotFoundOlx from './components/NotFoundOlx/NotFoundOlx';
import Mobile from './components/Mobile/Mobile';
import MultiSession from './components/MultiSession/MultiSession';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:parcelNumber?" element={<HomeTestPage />} />
        <Route path="/client/session/:sessionId?" element={<Session />} />
        <Route path="/findSession/:paymentNumber?" element={<Session />} />
        <Route path="/check/:checkId" element={<ChecksPage />} />
        <Route path="notFound" element={<NotFound />} />
        <Route path="notFoundOlx" element={<NotFoundOlx />} />
        <Route path="/m/:paymentNumber?" element={<Mobile />} />
        <Route path="/multi/:multiple_session_Id?" element={<MultiSession />} />
      </Routes>
    </Router>
  );
}

export default App;
